module.exports = __webpack_public_path__ + "img/ic-copy.fa21f339.svg";